// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedLensSingleUse_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M12.946 24H14.758V15.432H13.27L10.51 17.628 11.386 18.72 12.37 17.928C12.482 17.832 12.602 17.724 12.73 17.604 12.866 17.476 12.954 17.388 12.994 17.34 12.978 17.596 12.966 17.896 12.958 18.24 12.95 18.576 12.946 18.844 12.946 19.044V24ZM21.9226 24H23.9986L21.1066 19.68 23.7946 15.432H21.8386L20.0266 18.516 18.1786 15.432H16.1746L18.8386 19.584 15.9946 24H17.9386L19.9306 20.76 21.9226 24Z" class="svg-bg"/>
  <path d="M21.8982 13.432C21.9653 12.9643 22 12.4862 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.2345 6.02186 21.5296 11.144 21.9639V23.9699C4.91608 23.531 0 18.3396 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 12.4846 23.9713 12.9624 23.9154 13.432H21.8982Z" class="svg-bg"/>
  <path d="M6 11.9381C6 8.96511 8.16229 6.49714 11 6.02106V4C7.05369 4.4921 4 7.85849 4 11.9381L4.00023 12H6.00031C6.0001 11.9794 6 11.9588 6 11.9381Z" class="svg-bg"/>
</svg>
`;
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M29.4202 20C29.7974 18.7326 30 17.3899 30 16C30 8.26801 23.732 2 16 2C8.26801 2 2 8.26801 2 16C2 23.732 8.26801 30 16 30C16.3362 30 16.6697 29.9881 17 29.9648V31.9693C16.6693 31.9897 16.3358 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 17.3812 31.825 18.7215 31.4959 20H29.4202Z" class="svg-bg"/>
  <path d="M20.956 31.996H18.842V26.214C18.842 25.9807 18.8467 25.668 18.856 25.276 18.8653 24.8747 18.8793 24.5247 18.898 24.226 18.8513 24.282 18.7487 24.3847 18.59 24.534 18.4407 24.674 18.3007 24.8 18.17 24.912L17.022 25.836 16 24.562 19.22 22H20.956V31.996ZM32 31.996H29.578L27.254 28.216 24.93 31.996H22.662L25.98 26.844 22.872 22H25.21L27.366 25.598 29.48 22H31.762L28.626 26.956 32 31.996ZM6 15.9999C6 10.8146 9.94668 6.55104 15 6.04932V4.04102C8.84047 4.54917 4 9.70928 4 15.9999H6Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedLensSingleUse is a generated icon component.
 */
let IconMedLensSingleUse = IconMedLensSingleUse_1 = class IconMedLensSingleUse extends IconBaseElement {
    render() {
        return html `${IconMedLensSingleUse_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedLensSingleUse.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconMedLensSingleUse = IconMedLensSingleUse_1 = __decorate([
    customElement('zui-icon-med-lens-single-use')
], IconMedLensSingleUse);
export { IconMedLensSingleUse };
